<template>
  <div
      class="relative cursor-pointer bg-center bg-no-repeat bg-cover text-white
      text-center font-bold text-[24px] pc:w-[260px] pc:h-[120px] mobile:h-[100px] rounded-[20px]"
      :style="backgroundStyle"
      @click="onSearch"
  >
    <div class="absolute inset-0 bg-black/30 flex items-center justify-center rounded-[20px]">
      <span class="drop-shadow-md">{{ name }}</span>
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from "vue"
import {useGoTo} from "@/composables/useGoTo";
import {useSearchQueryStore} from "@/stores/searchQuery";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useImageUrl} from '~/composables/useImageUrl';

const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL+'images/';
const currentImage = ref('');       // 儲存實際要顯示的圖片 URL

const searchQueryStore = useSearchQueryStore()
const {goWithQuery, go} = useGoTo();
const {handleSearchWithStore} = useSearchWithStore()


const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  imgName: {
    type: String,
    default: ''
  },
  searchId: {
    type: Number,
    default: 0
  },
  searchStore: {
    type: Function
  },
  slug: {
    type: String,
    default: ''
  },

})
const getImageUrl = useImageUrl;
/*const backgroundStyle = computed(() => ({
  backgroundImage: `url(${getImageUrl('background/search', props.imgName + '.png')})`
}));*/

function checkImage(url) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

async function setImage() {
  const primary = `${picUrl}${props.slug}.png`;
  // new Image() 是瀏覽器專屬 API，SSR 端直接用主圖當預設，避免 "Image is not defined"
  if (import.meta.server) {
    currentImage.value = primary;
    return;
  }
  const exists = await checkImage(primary);
  currentImage.value = exists ? primary : `${picUrl}other.png`;
}

// 監看 props.slug 變動時重新判斷
watch(() => props.slug, () => {
  setImage();
}, { immediate: true });

const backgroundStyle = computed(() => ({
  backgroundImage: `url(${currentImage.value})`
}));


function onSearch() {
  if (props.slug) {
    go('/list/' + props.slug)
  } else {
    searchQueryStore.initQueryDate()
    props.searchStore([props.searchId])
    goWithQuery('/search-result', {})
    handleSearchWithStore()
  }
}

</script>
<style scoped
       lang="scss">
.card-wrap {
  @apply font-bold text-[24px] text-center text-osn-white-00 cursor-pointer  bg-contain bg-no-repeat bg-center
  pc:w-[260px] pc:h-[120px] pc:leading-[120px] pc:bg-cover
  mobile:h-[100px] mobile:leading-[100px];
}

</style>
